"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const tooltip_1 = __importDefault(require("@kyruus/tooltip"));
const ui_theme_1 = require("@kyruus/ui-theme");
const CancelCircle_1 = __importDefault(require("@kyruus/react-ikons/CancelCircle"));
const EventAvailable_1 = __importDefault(require("@kyruus/react-ikons/EventAvailable"));
const MiniProviderBookAndReferCard_styles_1 = require("./MiniProviderBookAndReferCard.styles");
const MiniProviderContent_1 = require("../MiniProviderContent");
const types_1 = require("../types");
const useProviderContent_1 = require("../common/util/useProviderContent");
/**
 * A component for rendering small, interactive provider cards.
 */
const MiniProviderBookAndReferCard = (0, react_1.forwardRef)((_a, ref) => {
    var { id, provider, location, config = {}, hideFields = [types_1.ShowField.SPECIALTY, types_1.ShowField.AVAILABILITY], status, track, availability, onRemoveReferral } = _a, restProps = __rest(_a, ["id", "provider", "location", "config", "hideFields", "status", "track", "availability", "onRemoveReferral"]);
    const { name, locationName } = (0, useProviderContent_1.useProviderContent)({
        provider,
        location,
        config
    });
    const label = (0, react_1.useMemo)(() => {
        return ([name, locationName, status].filter((a) => a).join(', ') || undefined);
    }, [locationName, name, status]);
    const iconSize = (0, react_1.useMemo)(() => (0, ui_theme_1.fromTheme)('font_size_heading_4')(restProps), [restProps]);
    const bookedIconColor = (0, react_1.useMemo)(() => (0, ui_theme_1.fromTheme)('color_success')(restProps), [restProps]);
    const handleRemoveReferral = (0, react_1.useCallback)((event) => {
        event.persist();
        if (onRemoveReferral) {
            onRemoveReferral(event, {
                provider,
                location,
                config,
                status
            });
        }
        if (track) {
            track({ provider, config, location, status });
        }
    }, [config, location, onRemoveReferral, provider, status, track]);
    const actions = (0, react_1.useMemo)(() => {
        if (status === types_1.ProviderStatus.REFERRED) {
            return [
                {
                    id: 'remove',
                    label: 'Remove referral',
                    icon: (react_1.default.createElement(CancelCircle_1.default, { size: iconSize, title: "Remove referral", "aria-hidden": true })),
                    onActivate: handleRemoveReferral
                }
            ];
        }
        if (status === types_1.ProviderStatus.BOOKED) {
            return [
                {
                    id: 'booked',
                    label: 'Booked',
                    disabled: true,
                    icon: (react_1.default.createElement(EventAvailable_1.default, { size: iconSize, color: bookedIconColor, title: "Booked", "aria-hidden": true }))
                }
            ];
        }
        return [];
    }, [bookedIconColor, handleRemoveReferral, iconSize, status]);
    const tooltipTitle = (react_1.default.createElement(MiniProviderBookAndReferCard_styles_1.ProviderImageTooltipText, null,
        react_1.default.createElement("span", null, name),
        react_1.default.createElement("span", null, locationName),
        react_1.default.createElement("span", null, status)));
    return (react_1.default.createElement(MiniProviderBookAndReferCard_styles_1.Card, Object.assign({ id: id, label: label, actions: actions, ref: ref }, restProps),
        react_1.default.createElement(tooltip_1.default, { title: tooltipTitle, id: `tooltip-${name}` },
            react_1.default.createElement(MiniProviderContent_1.MiniProviderContent, { id: id, hideFields: hideFields, provider: provider, location: location, config: config, availability: availability }))));
});
MiniProviderBookAndReferCard.displayName = 'MiniProviderBookAndReferCard';
exports.default = MiniProviderBookAndReferCard;
//# sourceMappingURL=MiniProviderBookAndReferCard.js.map